import React, { useMemo } from 'react';
import Modal from 'react-modal';
import { isUndefined } from 'lodash/fp';

import { SidebarMenu, SidebarMenuProps } from '../sidebar-menu/SidebarMenu';
import styles from './Modal.module.scss';
import { ModalHeader } from './ModalHeader';

interface SidebarMenuModalProps extends SidebarMenuProps {
    isOpen: boolean;
    closeModal?: () => void;
    buttonWrapper: JSX.Element | null;
    headerIcon: React.FC;
    headerLabel: string;
    closeOnOverlayClick?: boolean;
    showOverlay?: boolean;
    zIndex?: number;
    maxWidth?: number;
    wrapperClassName?: string;
    sidebarWidth?: number;
}

export const SidebarMenuModal: React.FC<SidebarMenuModalProps> = ({
    isOpen,
    closeModal,
    sections,
    selected,
    openSection,
    testId,
    menuDisabled,
    buttonWrapper,
    headerLabel,
    headerIcon,
    closeOnOverlayClick = false,
    showOverlay = true,
    zIndex = 10,
    maxWidth,
    wrapperClassName = styles.modal,
    sidebarWidth = 150
}) => {
    const defaultOverlayStyle = showOverlay ? { display: 'flex', zIndex } : { display: 'flex', backgroundColor: 'transparent', zIndex };
    const height = useMemo(() => {
        let heightOffset = 46;
        if (!isUndefined(buttonWrapper)) {
            heightOffset += 48;
        }
        return `calc(100% - ${heightOffset}px)`;
    }, [buttonWrapper]);

    return (
        <Modal
            isOpen={isOpen}
            className={wrapperClassName}
            ariaHideApp={false}
            style={{ overlay: defaultOverlayStyle, content: { maxWidth: maxWidth ? `${maxWidth}%` : '' } }}
            shouldCloseOnOverlayClick={closeOnOverlayClick}
            shouldCloseOnEsc={closeOnOverlayClick}
            onRequestClose={closeModal}
        >
            <div className={styles.sidebarModalWrapper} data-testid={`${testId}-modal-wrapper`}>
                <ModalHeader icon={headerIcon} label={headerLabel} testId={testId} marginBottom='0px' />
                <div style={{ height }}>
                    <SidebarMenu
                        sections={sections}
                        selected={selected}
                        openSection={openSection}
                        testId={testId}
                        menuDisabled={menuDisabled}
                        sidebarWidth={sidebarWidth}
                    />
                </div>
                {buttonWrapper}
            </div>
        </Modal>
    );
};
